export type Charity = {
  name: string;
  url?: string;
};

// Charities Council 1056 has supported over the years.
// Only add `url` when an official website has been verified.
const CHARITIES: Charity[] = [
  { name: 'Central Ohio Veterans Stand Down', url: 'https://www.centralohiostanddown.org/' },
  { name: 'People In Need (PIN)', url: 'https://www.delawarepeopleinneed.org/' },
  { name: 'Pregnancy Resource Center', url: 'https://pregnantdelawarecounty.org/' },
  { name: 'Common Ground Free Store Ministries', url: 'https://commongroundfreestore.org/' },
  { name: 'Damascus', url: 'https://www.damascus.net/' },
  { name: 'Delaware County Humane Society', url: 'https://hsdcohio.org/' },
  { name: 'Delaware Suicide Prevention Coalition', url: 'https://connections.galaxydigital.com/agency/detail/?agency_id=124437' },
  { name: 'Delaware YMCA', url: 'https://ymcacolumbus.org/locations/delaware' },
  { name: 'Easter Seals of Central Ohio', url: 'https://cseohio.easterseals.com/' },
  { name: 'Honor Flight Columbus', url: 'https://www.honorflightcmh.org/' },
  { name: 'Columbus Right to Life', url: 'https://www.gcrtl.org/' },
  { name: "Men's Conference Sponsorship", url: 'https://www.catholicmensministry.com/' },
  { name: 'Mission Warmth', url: 'https://www.mission-warmth.org/' },
  { name: 'Mommies Matter', url: 'https://mommiesmatter.org/' },
  { name: "MSDC, Inc (Men's Shelter)", url: 'https://www.stvincentnewbeginnings.org/' },
  { name: 'Springs of Love - Fostering & Adoption', url: 'https://springsoflove.org/' },
  { name: 'St Mary Catholic Church', url: 'https://www.delawarestmary.org/' },
  { name: 'St Mary SPO', url: 'https://www.delawarestmary.org/parishorganizations' },
  { name: 'SPICE', url: 'https://www.delawarestmary.org/spice' },
  { name: 'St Vincent DePaul', url: 'https://www.delawarestmary.org/socialjustice' },
  { name: 'Stock Hands Horses for Healing', url: 'https://www.stockhands.org/' },
  { name: 'Westerville Special Olympics', url: 'https://westervillespecialolympics.com/' },
  { name: 'Women of St. Mary', url: 'https://www.delawarestmary.org/parishorganizations' },
  { name: 'American Heritage Girls - Troop 6279' },
];

// export const SORTED_CHARITIES: Charity[] = [...CHARITIES].sort((a, b) => {
//   const x = a.name.toLowerCase();
//   const y = b.name.toLowerCase();
//   return x < y ? -1 : x > y ? 1 : 0;
// });

export default CHARITIES;